<template>
  <header>
    <h1 id="logo">Let me search that for you</h1>
  </header>
</template>
